function setOpenDrawerSuccess(payload) {
  return {
    type: 'SET_OPEN_DRAWER',
    payload
  };
}

export function setOpenDrawer(drawer, touched) {
  return dispatch => {
    dispatch(setOpenDrawerSuccess({drawer, touched}));
  };
}
